export enum ButtonStatusEnum {
    ACTIVE = 'active',
    HIDDEN = 'hidden',
    // INACTIVE = 'inactive',
}

export const ButtonStatusLabels = {
    [ButtonStatusEnum.ACTIVE]: 'Ativo',
    // [ButtonStatusEnum.INACTIVE]: 'Inativo',
    [ButtonStatusEnum.HIDDEN]: 'Oculto (não será exibido na inicialização do bot)',
}